import { render, staticRenderFns } from "./CaPlatform.vue?vue&type=template&id=2f5cac4d&"
import script from "./CaPlatform.vue?vue&type=script&lang=js&"
export * from "./CaPlatform.vue?vue&type=script&lang=js&"
import style0 from "./CaPlatform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports